import axios from '../../axios'

/*
 * 消息推送管理后台接口
 */

// 消息推送管理后台接口（增删改查）
export const pushApi = (data) => {
    return axios({
        url: '/api/admin/push',
        method: data.method || 'GET',
        data: data.data
    })
}

// 查看分页日志
export const logApi = (data) => {
    return axios({
        url: '/api/admin/push/log',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/push.js